import { askDockTab } from "./dockBridge.js";

// Jobs a surface runs for the reader outside a chat's own turns (the board's
// "Walk me through it" walking through it), put in the chat in front as the
// card the chat's own call of that job shows (components/ChatConsole.jsx
// JobNode), the chat brought in front. Run so, a job is the reader's own
// click, never the model's choice, so a chat that knows the traces already
// cannot answer in its place.
const listeners = new Set();
let seq = 0;

/**
 * Puts job `{ kind, key }` (kind "walkthrough": `key` the walkthrough's)
 * in the chat in front. False where no chat console is up to take it.
 */
export function postChatJob(job) {
    if (!job?.kind || !job.key || !listeners.size) return false;
    seq += 1;
    const item = { kind: "job", id: `job-${Date.now().toString(36)}-${seq}`, job: String(job.kind), key: String(job.key), at: Date.now() };
    for (const fn of listeners) fn(item);
    askDockTab("chat");
    return true;
}

export function onChatJob(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
